import { Select } from './';
import { serializeModelValue, createOnModelChange } from './common';

import React from 'react';
import PropTypes from 'prop-types';

const ContestSelect = ({
  options,
  value,
  multiple,
  onChange,
  meta,
  ...props
}) => {
  const modelOptions = {
    complexPrimaryKey: true,
    multiple,
  };

  const selectOptions = options.map(contest => ({
    key: contest.id,
    value: JSON.stringify(contest.primaryKey),
    text: contest.title,
    description: `${contest.ageGroup.title} ${
      contest.bodyweightCategory.title
    }`,
  }));

  return (
    <Select
      {...props}
      multiple={multiple}
      options={selectOptions}
      value={serializeModelValue(value, modelOptions)}
      onChange={createOnModelChange(onChange, modelOptions)}
    />
  );
};

ContestSelect.propTypes = {
  meta: PropTypes.shape({
    contests: PropTypes.array.isRequired,
  }).isRequired,
};

export default ContestSelect;



// WEBPACK FOOTER //
// ./src/components/ContestSelect.js